module.exports = __webpack_public_path__ + "img/P150T_weapon_15.8a43f4a7.png";